export default "__VITE_ASSET__BEkq$qhC__"